import { Component, inject, Input, OnInit } from '@angular/core';
import { ParentItemProviderService } from '@app/shared';
import { ItemWithSelection } from '@app/shared/models/item-with-selection';
import { DynamicFormService } from '@ntap/common';
import {
  Item,
  ItemViewProviderDirective,
  ListViewProviderDirective,
  NtapGlobalConstants,
  Util
} from '@ntap/core';
import { PrimeNGPropertyPaneComponent } from '@ntap/primeng';
import {
  first,
  map,
  mergeMap,
  Observable,
  switchMap,
  tap,
  withLatestFrom
} from 'rxjs';
import {
  ObrazacUnosaDTO,
  ObrazacUnosaService
} from '../fast-data-entry/service/obrazac-unosa.service';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: '[app-fast-data-entry-input-bar]',
  templateUrl: './fast-data-entry-input-bar.component.html',
  styleUrls: ['./fast-data-entry-input-bar.component.scss']
})
export class FastDataEntryInputBarComponent
  extends PrimeNGPropertyPaneComponent
  implements OnInit
{
  selectedEntryTemplate: number | undefined;

  @Input()
  tableItemsLength: number;

  multivalueActionState$: Observable<{ disabled: boolean }>;

  amount: number;

  private fastDataEntryService = inject(ObrazacUnosaService);
  private parentJedinicaItemProvider = inject(ParentItemProviderService);
  private obrazacUnosItemViewProvider = inject(ItemViewProviderDirective);
  private brziUnosListListViewProvider = inject(ListViewProviderDirective);
  private formService = inject(DynamicFormService);

  viewItem$: Observable<Item>;

  ngOnInit() {
    this.multivalueActionState$ =
      this.brziUnosListListViewProvider.selectedItems$.pipe(
        map((s) => {
          return { disabled: s.length <= 0 };
        })
      );
  }

  addAmountUsingTemplate() {
    this.executeActionWithEntryTemplateParams('addUsingEntryTemplate', {
      $amount: this.amount || 1
    }).subscribe();
  }

  applyEntryTemplate() {
    this.brziUnosListListViewProvider.selectedItems$
      .pipe(
        first(),
        mergeMap((selectedItems) => {
          const selection: ItemWithSelection = {
            $selected: Util.mapToBasicItemData(selectedItems),
            $listName: this.brziUnosListListViewProvider.viewName
          };
          return this.executeActionWithEntryTemplateParams(
            'applyUsingEntryTemplate',
            selection
          );
        })
      )
      .subscribe();
  }

  deleteSelectedJedinice() {
    this.brziUnosListListViewProvider.selectedItems$
      .pipe(
        first(),
        mergeMap((selectedItems) => {
          const selection: ItemWithSelection = {
            $selected: Util.mapToBasicItemData(selectedItems),
            $listName: this.brziUnosListListViewProvider.viewName
          };
          return this.executeActionWithEntryTemplateParams(
            'softDeleteMultipleItemsJedinicaGradiva',
            selection
          );
        })
      )
      .subscribe();
  }

  private executeActionWithEntryTemplateParams(
    actionName: string,
    actionParams: any
  ) {
    return this.parentJedinicaItemProvider.parentItem$
      .pipe(withLatestFrom(this.obrazacUnosItemViewProvider.item$))
      .pipe(
        first(),
        switchMap(
          ([parentJedinica, obrazacJedinica]: [
            parentItem: any,
            item: Item
          ]) => {
            const parentType =
              parentJedinica[NtapGlobalConstants.ATTR_$itemType];
            const params = Object.assign(
              {},
              obrazacJedinica,
              this.formService.getFormValues(),
              Object.assign(
                {
                  $parentType: parentType,
                  $parentId:
                    parentJedinica[
                      Util.getFullAttrName(
                        parentType,
                        NtapGlobalConstants.ATTR_id
                      )
                    ],
                  $entryTemplateViewName:
                    this.obrazacUnosItemViewProvider.viewName
                },
                actionParams
              )
            );
            return this.obrazacUnosItemViewProvider
              .executeAction(actionName, params)
              .pipe(
                tap(() => {
                  // FIXME trebati će vratiti sa servera nove id-ove pa samo njih refreshati
                  this.brziUnosListListViewProvider.refresh();
                })
              );
          }
        )
      );
  }

  selectEntryTemplate(template: ObrazacUnosaDTO) {
    this.fastDataEntryService.selectEntryTemplate(template);
  }

  getInputParam(input: any) {
    input.showInOverlay = true;
    return input;
  }
}
